import bfPopover from './bf-popover.vue';
bfPopover.install = Vue => Vue.component(bfPopover.name,bfPopover);
export default bfPopover;



// WEBPACK FOOTER //
// ./src/packages/popover/index.js